(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(function ($) {
  "use strict"; // five-star-slide--um

  var swiper = new Swiper('#five-reason-slide-01', {
    pagination: {
      el: '#swiper-pagination01',
      type: 'fraction'
    },
    navigation: {
      nextEl: '#swiper-button-next01',
      prevEl: '#swiper-button-prev01'
    }
  });
  var swiper = new Swiper('#five-reason-slide-02', {
    pagination: {
      el: '#swiper-pagination02',
      type: 'fraction'
    },
    navigation: {
      nextEl: '#swiper-button-next02',
      prevEl: '#swiper-button-prev02'
    }
  });
  var swiper = new Swiper('#five-reason-slide-03', {
    pagination: {
      el: '#swiper-pagination03',
      type: 'fraction'
    },
    navigation: {
      nextEl: '#swiper-button-next03',
      prevEl: '#swiper-button-prev03'
    }
  });
  var swiper = new Swiper('#five-reason-slide-04', {
    pagination: {
      el: '#swiper-pagination04',
      type: 'fraction'
    },
    navigation: {
      nextEl: '#swiper-button-next04',
      prevEl: '#swiper-button-prev04'
    }
  });
  var swiper = new Swiper('#five-reason-slide-05', {
    pagination: {
      el: '#swiper-pagination05',
      type: 'fraction'
    },
    navigation: {
      nextEl: '#swiper-button-next05',
      prevEl: '#swiper-button-prev05'
    }
  }); //product-detail-vertical

  var galleryThumbs = new Swiper('#gallery-thumbs', {
    slidesPerView: 3,
    breakpoints: {
      767: {
        slidesPerView: 5,
        spaceBetween: 2,
        direction: 'horizontal',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true
      }
    }
  });
  var galleryTop = new Swiper('#gallery-top', {
    spaceBetween: 0,
    thumbs: {
      swiper: galleryThumbs
    },
    breakpoints: {
      767: {
        spaceBetween: 2,
        direction: 'horizontal',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true
      }
    }
  }); // product-detail-tab

  var tabThumbs = new Swiper('#tab-thumbs', {
    spaceBetween: 2,
    slidesPerView: 1.5,
    freeMode: true,
    // autoHeight: true, //enable auto height
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '#tab-thumbs-next',
      prevEl: '#tab-thumbs-prev'
    },
    breakpoints: {
      767: {
        slidesPerView: 4
      }
    }
  });
  var tabContent = new Swiper('#tab-contents', {
    spaceBetween: 0,
    effect: 'fade',
    autoHeight: true,
    //enable auto height
    preloadImages: false,
    lazyLoading: true,
    allowTouchMove: false,
    slidesPerView: 1,
    thumbs: {
      swiper: tabThumbs
    }
  }); // product-detail-tab内側のスライド

  $(function () {
    var $tab = $('.o-illumination-m-tab');
    var tabListNum = $tab.find('.swiper-slide').length; // console.log(tabListNum);

    var num;

    for (var i = 1; i <= tabListNum; i++) {
      if (i < 10) {
        num = '0' + i;
      } else {
        num = i;
      }

      var innerSlide = new Swiper('#innerSlide' + num, {
        spaceBetween: 0,
        navigation: {
          nextEl: '#innerSlide-next' + num,
          prevEl: '#innerSlide-prev' + num
        }
      });
    }
  }); // ---------------------------------limited line ページ

  var swiper = new Swiper('#limitedSwiper01', {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });
  var swiper = new Swiper('#limitedSwiper02', {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false // reverseDirection: true,

    }
  }); // ---------------------------------トップページ

  var swiper = new Swiper('#mapZoneSlider', {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  }); // tab

  $(function () {
    var $indexProTab = $("#indexProTab");
    var $indexProContents = $("#indexProContents");
    $indexProTab.find("li").on('click', function () {
      $indexProTab.find("li").removeClass("active");
      $(this).addClass("active");
      var proTarget = $(this).attr('data-target'); // console.log("#" + proTarget);

      $indexProContents.find(".__each").removeClass("show");
      $("#" + proTarget).addClass("show");
      tabContentsHeight();
    });
    tabContentsHeight();

    function tabContentsHeight() {
      var tabContentsHeight = $indexProContents.find(".show").innerHeight();
      $indexProContents.css('height', tabContentsHeight + "px");
    }
  }); // product

  $(function () {
    $('#productItemNav .__item-list').hover(function () {
      var group = $(this).parents('#productItem');
      group.find('.active').removeClass('active');
      var index = $(this).index();
      group.find(".__info").eq(index).addClass('active');
    });
  }); // --------------------------------共通
  // fixed_contact--um

  $(function () {
    $("#o-illuminaion-fixed-contact-close").on('click', function () {
      $("#o-illuminaion-fixed-contact").addClass("__hide");
    });
  }); // index-facebook

  $(function () {
    $("#facebookClose").on('click', function () {
      $("#facebook").addClass("__hide");
    });
  }); // モーダルウィンドウ

  $(function () {
    $('.js-modal-open').each(function () {
      $(this).on('click', function () {
        var target = $(this).data('target');
        var modal = document.getElementById(target);
        $(modal).fadeIn();
        return false;
      });
    });
    $('.js-modal-close').on('click', function () {
      $('.js-modal').fadeOut();
      return false;
    });
  }); //effect-fade

  $(function () {
    $(window).on('load', function () {
      scroll_effect();
      $(window).scroll(function () {
        scroll_effect();
      });

      function scroll_effect() {
        $('.effect-fade').each(function () {
          var elemPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();

          if (scroll > elemPos - windowHeight) {
            $(this).addClass('effect-scroll');
          }
        });
      }
    });
  }); // accordion

  $(function () {
    $(".accordionbox dt").on("click", function () {
      $(this).next().slideToggle(); // activeが存在する場合

      if ($(this).children(".accordion_icon").hasClass('active')) {
        // activeを削除
        $(this).children(".accordion_icon").removeClass('active');
      } else {
        // activeを追加
        $(this).children(".accordion_icon").addClass('active');
      }
    });
  }); // quality横ナビゲーション

  $(function () {
    if ($("#pageContents").length) {
      var $window = $(window);
      var $contentsSideNav = $("#contentsSideNav");
      var $contentsTopNav = $("#contentsTopNav");
      $window.on('load', function () {
        $contentsTopNav.find("a").on('click', function () {
          $contentsSideNav.find("a").removeClass("active");
          var sideTarget = $(this).attr("data-sidetarget");
          $(sideTarget).addClass("active");
        });
        $contentsSideNav.find("a").on('click', function () {
          $contentsSideNav.find("a").removeClass("active");
          $(this).addClass("active");
          var target = $(this).attr("href");
        });
        var contentsNum = $contentsSideNav.find("a").length; // console.log(contentsNum);

        var _loop = function _loop(i) {
          var num = void 0;

          if (i < 10) {
            num = "0" + i;
          } else {
            num = i;
          } // console.log(num);


          var next = void 0,
              nextNum = void 0;
          next = i + 1;

          if (next < 10) {
            nextNum = "0" + next;
          } else {
            nextNum = next;
          } // console.log(nextNum);
          // const $quality01 = $("#quality01");


          var qualityName = eval($("#contents" + num)); // console.log(qualityName);
          // const $quality02 = $("#quality02");

          if (i < contentsNum) {
            qualityNextName = eval($("#contents" + nextNum));
          } else {
            qualityNextName = eval($("#contentslast"));
          } // console.log(qualityNextName);


          var adjustNum = 100;
          var qualityTop = qualityName.offset().top - adjustNum;
          var qualityNextTop = qualityNextName.offset().top - adjustNum;

          function sideFixNavi() {
            if ($window.scrollTop() > qualityTop && $window.scrollTop() < qualityNextTop) {
              $("#sideNavi" + num).addClass("active");
            } else {
              $("#sideNavi" + num).removeClass("active");
            }
          }

          sideFixNavi();
          $window.scroll(function () {
            sideFixNavi();
          });
        };

        for (var i = 1; i <= contentsNum; i++) {
          var qualityNextName;
          var qualityNextName;
          var qualityNextName;

          _loop(i);
        }
      });
    }
  }); //quick-fix-systemタブ

  $(function () {
    if ($("#qfsTabContents").length) {
      var calcHeight = function calcHeight() {
        var qfsTabContentsHeight = $qfsTabContents.find(".active").innerHeight();
        $qfsTabContents.css("height", qfsTabContentsHeight + "px"); // console.log(qfsTabContentsHeight);
      };

      var qfsTabImgAreaHeight = function qfsTabImgAreaHeight() {
        var qfsTabImgAreaHeight = $qfsTabImgArea.children(".__img-area").find("img").innerHeight();
        $qfsTabImgArea.children(".__img-area").css("height", qfsTabImgAreaHeight + "px");
      };

      var $qfsTabNavi = $("#qfsTabNavi");
      var $qfsTabContents = $("#qfsTabContents");
      var $qfsTabImgArea = $("#qfsTabImgArea");
      var $imgHoverArea = $("#imgHoverArea");
      var tabTarget;
      var imgTarget;
      $(window).on('load', function () {
        calcHeight();
        qfsTabImgAreaHeight();
      });
      $(window).resize(function () {
        calcHeight();
        qfsTabImgAreaHeight();
      }); // タブをクリックしたときの挙動

      $qfsTabNavi.find("li").on('click', function () {
        $qfsTabNavi.find("li").removeClass("active");
        $(this).addClass("active");
        tabTarget = $(this).attr("data-target");
        $qfsTabContents.find(".__each").removeClass("active");
        $qfsTabContents.find("#" + tabTarget).addClass("active");

        if ($qfsTabImgArea.find("img.active").attr("data-target") !== tabTarget) {
          $qfsTabImgArea.children(".__img-area").children("img").removeClass("active");
          $qfsTabImgArea.children(".__img-area").children("img").each(function () {
            if ($(this).attr("data-target") === tabTarget) {
              $(this).addClass("active");
            }
          });
        } else {}

        calcHeight();
      });
      $imgHoverArea.on({
        'mouseenter': function mouseenter() {},
        'mouseleave': function mouseleave() {
          $qfsTabImgArea.children(".__img-area").children("img").removeClass("active");
          $qfsTabNavi.find("li").removeClass("active");
          $qfsTabContents.find(".__each").removeClass("active");
          $qfsTabImgArea.children(".__img-area").children("img.first").addClass("active");
          $qfsTabNavi.find(".first").addClass("active");
          $qfsTabContents.find(".first").addClass("active");
          calcHeight();
        }
      });
      $imgHoverArea.find(".area").on({
        'mouseenter': function mouseenter() {
          imgTarget = $(this).attr("data-target");

          if ($qfsTabImgArea.find("img.active").attr("data-target") !== imgTarget) {
            $qfsTabImgArea.children(".__img-area").children("img").removeClass("active");
            $qfsTabImgArea.children(".__img-area").children("img").each(function () {
              if ($(this).attr("data-target") === imgTarget) {
                $(this).addClass("active");
              }
            });
          }

          if ($qfsTabNavi.find(".active").attr("data-target") !== imgTarget) {
            $qfsTabNavi.find("li").removeClass("active");
            $qfsTabNavi.find("li").each(function () {
              if ($(this).attr("data-target") === imgTarget) {
                $(this).addClass("active");
              }
            });
          }

          if ($qfsTabContents.find(".active").attr("id") !== imgTarget) {
            $qfsTabContents.find(".__each").removeClass("active");
            $qfsTabContents.find("#" + imgTarget).addClass("active");
            calcHeight();
          } else {}
        },
        'mouseleave': function mouseleave() {}
      });
    }
  });
  $(function () {
    $('.o-illumination-ttl04').matchHeight();
  });
});

},{}]},{},[1]);
